// src/components/DatosEmpleado/hooks/useExperiencia.js
import { useState } from 'react';
import {
    obtenerExperienciasPorEmpleado, agregarExperienciaAEmpleado,
    actualizarExperienciaEmpleado, eliminarExperienciaDeEmpleado
} from '../../../services/empleado/empleadoDetalleService';

const emptyExperiencia = {
    id: null, empresa: '', fechaIngreso: null,
    fechaSalida: null, motivoSalida: '', proyecto: '', tiempoExperiencia: ''
};

export const useExperiencia = ({ empleadoId, toast }) => {
    const [experiencias, setExperiencias] = useState([]);
    const [experienciaData, setExperienciaData] = useState(emptyExperiencia);
    const [experienciaDialog, setExperienciaDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const convertirFecha = (f) => {
        if (!f) return null;
        // Si viene como arreglo [año, mes, día] de Java LocalDate
        if (Array.isArray(f)) return new Date(f[0], f[1] - 1, f[2]);
        // Si viene como objeto con propiedades
        if (typeof f === 'object' && f.year) return new Date(f.year, f.monthValue - 1, f.dayOfMonth);
        // Intento de parseo directo
        const d = new Date(f);
        return isNaN(d.getTime()) ? null : d;
    };

    const recargarExperiencias = async (id) => {
        if (!id) return;
        try {
            const data = await obtenerExperienciasPorEmpleado(id);
            
            setExperiencias(data.map(e => ({
                id: e.experienciaLaboralId, // CORRECCIÓN: Este es el nombre que viene del Dominio
                empresa: e.nombreEmpresa,
                fechaIngreso: convertirFecha(e.fechaIngreso),
                fechaSalida: convertirFecha(e.fechaSalida),
                motivoSalida: e.motivoSalida,
                proyecto: e.proyecto,
                tiempoExperiencia: e.tiempoExperiencia
            })));
        } catch (e) { console.error(e); }
    };

    const openNewExperiencia = () => { setExperienciaData(emptyExperiencia); setExperienciaDialog(true); };
    const openEditExperiencia = (rowData) => { 
        //console.log ('DATOS EDIT..: ', rowData)
        setExperienciaData({ ...rowData }); 
        setExperienciaDialog(true); 
    };

    const saveExperiencia = async () => {
        if (!empleadoId) return;

        if (!experienciaData.empresa) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe llenar el campo Empresa' });
            return 
        }
        if (!experienciaData.fechaIngreso) {
            if (!experienciaData.tiempoExperiencia) {
                toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe llenar el campo Fecha Inicio o Tiempo Experiencia' });
                return
            }
        }

        const formatDate = (d) => d && d.toISOString ? d.toISOString().split('T')[0] : null;

        const payload = {
            experienciaLaboralId: experienciaData.id, // CORRECCIÓN: Nombre consistente con el DTO
            empleadoId: parseInt(empleadoId),
            nombreEmpresa: experienciaData.empresa,
            fechaIngreso: experienciaData.fechaIngreso ? formatDate(experienciaData.fechaIngreso) : "",
            fechaSalida: experienciaData.fechaSalida ? formatDate(experienciaData.fechaSalida) : "",
            motivoSalida: experienciaData.motivoSalida,
            proyecto: experienciaData.proyecto,
            tiempoExperiencia: experienciaData.tiempoExperiencia
        };

        try {
            setLoading(true);
            if (experienciaData.id) {
                await actualizarExperienciaEmpleado(payload); // Enviar payload con el nombre correcto
            } else {
                await agregarExperienciaAEmpleado(payload);
            }

            toast.current.show({ severity: 'success', summary: 'Éxito' });
            await recargarExperiencias(empleadoId);
            setExperienciaDialog(false);
        } catch (e) { toast.current.show({ severity: 'error', summary: 'Error' }); }
        finally { setLoading(false); }
    };

    const deleteExperiencia = async (rowData) => {
        if (!window.confirm("¿Eliminar experiencia laboral?")) return;
        try {
            await eliminarExperienciaDeEmpleado(rowData.id);
            toast.current.show({ severity: 'success', summary: 'Eliminado' });
            await recargarExperiencias(empleadoId);
        } catch (e) { toast.current.show({ severity: 'error', summary: 'Error' }); }
    };

    return { experiencias,
         experienciaData, 
         setExperienciaData, setExperiencias,
         experienciaDialog, setExperienciaDialog,
          openNewExperiencia, openEditExperiencia,
           saveExperiencia, deleteExperiencia, recargarExperiencias, loading };
};